import React from "react";
import {
  useDeleteModelMutation,
  useFetchModelsQuery,
} from "../../../../store/apis/modelApis";
import Box from "@mui/material/Box";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import { DataGrid } from "@mui/x-data-grid";
import { modelColumns } from "../utils/modelColumn";
import { setModel } from "../../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import {
  CONFIRM_DIALOG,
  MODEL_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import { useDispatch, useSelector } from "react-redux";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import ModelForm from "./ModelForm";
import ListHeader from "../../managementShared/ListHeader";
import TextField from "@mui/material/TextField";

const Model = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = React.useState("");
  const [pagination, setPagination] = React.useState({
    pageSize: 5,
    page: 0,
  });
  const { data: models, isLoading: modelsLoading } = useFetchModelsQuery(
    {
      searchText: searchText,
      page: pagination.page === 0 ? 1 : pagination.page + 1,
      limit: pagination.pageSize,
    },
    { refetchOnMountOrArgChange: true }
  );
  const rowCountRef = React.useRef(models?.data.totalRowCount || 0);
  const rowCount = React.useMemo(() => {
    if (models?.data.totalRowCount !== undefined) {
      rowCountRef.current = models?.data.totalRowCount;
    }
    return rowCountRef.current;
  }, [models?.data.totalRowCount]);
  const [deleteModel, { isLoading: deleteLoading }] = useDeleteModelMutation();
  const { model } = useSelector((state) => state.managementSlice);
  const { modelDialogOpen } = useSelector((state) => state.dialogSlice);
  const handleUpdate = (model) => {
    dispatch(setModel(model));
    dispatch(openDialog(MODEL_DIALOG));
  };
  const handleDelete = (model) => {
    dispatch(setModel(model));
    dispatch(openDialog(CONFIRM_DIALOG));
  };
  const closeDelete = () => {
    dispatch(setModel(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const postDelete = () => {
    deleteModel(model.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };
  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 10,
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Modeller" />
      {model && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Model Silme Onayı"
          text="Bu modeli silmek istediğinize emin misiniz?"
          isLoading={deleteLoading}
          handleClose={closeDelete}
        />
      )}
      {modelDialogOpen && <ModelForm />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          width: "100%",
        }}
      >
        <TextField
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Marka-Modele Göre Ara..."
          size="small"
          sx={{ width: 500 }}
        />
      </Box>
      <DataGrid
        rows={models?.data?.models || []}
        loading={modelsLoading}
        rowCount={rowCount}
        disableColumnMenu
        columns={modelColumns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        paginationMode="server"
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={MODEL_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default Model;
